import React from 'react'
import Construction from '../components/animations/Construction'

export default function Payment(props) {


  return (
    <Construction />
  )
}
